<template>
    <div>
        <v-card>
            <v-card-title>
               <v-icon> info </v-icon> Tarifálás adatai
            </v-card-title>
            <v-card-text>
                Tarifa id:{{tarifaId}} Id:{{id}}
            </v-card-text>
            <v-card-actions>
                <v-layout justify-end>
                    <v-btn>Tarifa másolása</v-btn>
                </v-layout>
            </v-card-actions>
        </v-card>
    </div>
</template>
<script>
export default {

    computed: {
        tarifaId() {
            return this.$store.getters.tarifaId;
        },

        id() {
            return this.$store.getters.id;
        },
    },

};
</script>
<style scoped>

</style>
